export default __webpack_public_path__ + "static/media/02.01d6c1f9.jpg";